import { AxiosError, AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Video API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const VideoApi: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.VIDEO_API,
    withCredentials: true,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken'
  }
})
export const fetchVideoDetails = (videoId: number) => {
  return VideoApi.get(`/apis/v1/player/videos/${videoId}/`).then(res => res.data)
}
